/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum HistoricoAutorizacaoConsultaAliases {
  AUTOCOMPLETE_DOMAIN = 'autocomplete-domain',
  AVATAR_SEGURADO = 'avatar-segurado',
  AVATAR_SEGURADO_MOB = 'avatar-segurado-mob',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DATE_FIELD_0 = 'date-field-0',
  DATE_FIELD_1 = 'date-field-1',
  DECK = 'deck',
  FETCH_BENEFICIARIO = 'fetch-beneficiario',
  FETCH_CONSULTA = 'fetch-consulta',
  FETCH_DOMAIN = 'fetch-domain',
  FIELD_CD_GUIA = 'field-cdGuia',
  FIELD_CD_GUIA_MOB = 'field-cdGuia-mob',
  FIELD_DOMAIN = 'field-domain',
  FIELD_DS_TIPO_GUIA = 'field-dsTipoGuia',
  FIELD_DS_TIPO_GUIA_MOB = 'field-dsTipoGuia-mob',
  FIELD_DT_FIM = 'field-dtFim',
  FIELD_DT_INICIO = 'field-dtInicio',
  FIELD_DT_SOLICITACAO = 'field-dtSolicitacao',
  FIELD_DT_SOLICITACAO_MOB = 'field-dtSolicitacao-mob',
  FIELD_FILTER_CD_GUIA = 'field-filter-cdGuia',
  FIELD_LOCATOR = 'field-locator',
  FIELD_SEGURADO = 'field-segurado',
  FIELD_SEGURADO_MOB = 'field-segurado-mob',
  FILTER_CONSULTA = 'filter-consulta',
  FILTERED_LIST_0 = 'filtered-list-0',
  HPMS_CUSTOM_CARD = 'hpms-custom-card',
  HPMS_DYNAMIC_CONTENT_FIELD_STAMP = 'hpms-dynamic-content-field-stamp',
  INPUT_0 = 'input-0',
  INPUT_CARTEIRA = 'input-carteira',
  LOCATOR_BENEFICIARIO = 'locator-beneficiario',
  LOCATOR_FIELD_0 = 'locator-field-0',
  MAPPER_DOMAIN = 'mapper-domain',
  MAPPER_SEGURADO = 'mapper-segurado',
  MAPPER_SEGURADO_MOB = 'mapper-segurado-mob',
  PANEL_0 = 'panel-0',
  PANEL_HISTORICO_AUTORIZACAO_CONSULTA = 'panel-historico-autorizacao-consulta',
  TEXT_CD_GUIA = 'text-cdGuia',
  TEXT_CD_GUIA_MOB = 'text-cdGuia-mob',
  TEXT_DOMAIN = 'text-domain',
  TEXT_DS_TIPO_GUIA = 'text-dsTipoGuia',
  TEXT_DS_TIPO_GUIA_MOB = 'text-dsTipoGuia-mob',
  TEXT_DT_SOLICITACAO = 'text-dtSolicitacao',
  TEXT_DT_SOLICITACAO_MOB = 'text-dtSolicitacao-mob',
}
export { HistoricoAutorizacaoConsultaAliases };
